export default "__VITE_ASSET__3QEWDRMP__"